import type { BeforeRetryHook } from "ky";
import ky, { HTTPError } from "ky";

let requestsToRefresh: (() => void)[] = [];
let isRefreshRequesting = false;
export const refreshToken: BeforeRetryHook = async ({ error }) => {
  if (
    error instanceof HTTPError &&
    error.response &&
    error.response.status === 401
  ) {
    if (!isRefreshRequesting) {
      isRefreshRequesting = true;

      // this api call on the auth will check if the token does not exists and then
      // it will refresh the token with a new one where it is sent as a set-cookie.
      ky("/auth/refresh-token")
        .then(() => {
          // after the api route is called, call all the failed 401 request calls
          for (const cb of requestsToRefresh) {
            cb();
          }
        })
        .catch(() => {
          // If the request failed, then there is no way to re-authenticate the user.
          // In dashboard we redirect the user to login to re-authenticate, here
          // we don't need to do that as the website is usable without being authenticated
          // so we just clear the state.
          window.location.href = "/auth/clear";
        })
        .finally(() => {
          requestsToRefresh = [];
          isRefreshRequesting = false;
        });
    }
    return new Promise((resolve) => {
      requestsToRefresh.push(() => {
        // retry the api call
        resolve();
      });
    });
  }
};
